import _ from "lodash";
import { useContext } from "react";

import Slider from "src/components/slider";
import Button from "src/components/button";

import { DealRoomActionPlanContext } from "../context";

import styles from "./styles.module.scss";

const DeleteStageSlider = ({ show, handleClose, handleFinish }) => {
  const { state } = useContext(DealRoomActionPlanContext);

  const deletingStageObj = _.get(state, "deletingStage", "");
  const stageId = _.get(deletingStageObj, "id", "");
  const loading = _.get(deletingStageObj, "loading", false);
  
  const allStages = _.get(state, "stages.items", []);
  const deletingStage = _.find(allStages, stage => _.get(stage, "id") === stageId);

  const totalActions = _.get(deletingStage, "totalActions", 0) ?? 0;
  const totalRecipients = _.get(deletingStage, "totalRecipients", 0) ?? 0;
  const totalAssets = _.get(deletingStage, "totalAttachments", 0) ?? 0;
  
  const handleConfirmClick = () => {
    handleFinish(stageId);
  }

  return (
    <Slider.Dialog width="400" show={show} onClose={handleClose}>
      <Slider.Header>
        <div className={styles.headerContainer}>
          <p className={styles.header}>deleting</p>
          <p className={styles.subtext}>
            Do you wish to delete this stage{" "}
            <span className={styles.highlight}>{`${_.get(deletingStage, "title", "")}`}</span> containing{" "}
            <span className={styles.highlight}>{`${totalActions} action item${totalActions > 1 ? "s" : ""}`}</span>?
          </p>
        </div>
      </Slider.Header>

      <Slider.Body>
        <div className={styles.bodyContainer}>
          <div className={styles.detailContainer}>
            <p className={styles.detailCount}>{`${totalRecipients} Stakeholder${totalRecipients > 1 ? "s" : ""}`}</p>
            <p className={styles.detailCount}>{`${totalAssets} Attachment${totalAssets > 1 ? "s" : ""}`}</p>
          </div>
          <p className={styles.footerNote}>
            Do you wish to delete this action stage?
          </p>
        </div>
      </Slider.Body>

      <Slider.Actions>
        <Button
          icon="paperflite-tick"
          text={loading ? "Confirming" : "Confirm"}
          variant="primary"
          onClick={handleConfirmClick}
          disabled={loading}
        />
        <Button text="Cancel" variant="secondary" onClick={handleClose} />
      </Slider.Actions>
    </Slider.Dialog>
  );
};

export default DeleteStageSlider;
